import { User } from "@ecologi/shared";

export const accountDetailsPageTitle = (user: User) =>
  user.isBusinessType ? "Account details" : "Personal details";
